/**
 * Generated by orval 🍺
 * Do not edit manually.
 * ISHONCH Platform API
 * Login: POST /api/v1/auth/otp → code (dev: in the app log) → POST /api/v1/auth/otp/verify → paste response_data.as_access_token into Authorize. Every response is the company envelope (ADR-0007).
 * OpenAPI spec version: v1
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  CartResponse,
  CheckoutQuoteRequest,
  GuestQuoteRequest,
  MergeCartRequest,
  QuoteResponse,
  SetQuantityRequest,
} from "../iSHONCHPlatformAPI.schemas";

import { httpRequest } from "../../http";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === "queryKey") continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getMyCartUrl = () => {
  return `/api/v1/checkout/cart`;
};

export const myCart = async (
  options?: Parameters<typeof httpRequest>[1],
): Promise<CartResponse> => {
  return httpRequest<CartResponse>(getMyCartUrl(), {
    ...options,
    method: "GET",
  });
};

export const getMyCartQueryKey = () => {
  return [`/api/v1/checkout/cart`] as const;
};

export const getMyCartQueryOptions = <
  TData = Awaited<ReturnType<typeof myCart>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof myCart>>, TError, TData>>;
  request?: SecondParameter<typeof httpRequest>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getMyCartQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof myCart>>> = ({ signal }) =>
    myCart({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof myCart>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type MyCartQueryResult = NonNullable<Awaited<ReturnType<typeof myCart>>>;
export type MyCartQueryError = unknown;

export function useMyCart<TData = Awaited<ReturnType<typeof myCart>>, TError = unknown>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof myCart>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof myCart>>,
          TError,
          Awaited<ReturnType<typeof myCart>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof httpRequest>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useMyCart<TData = Awaited<ReturnType<typeof myCart>>, TError = unknown>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof myCart>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof myCart>>,
          TError,
          Awaited<ReturnType<typeof myCart>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof httpRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useMyCart<TData = Awaited<ReturnType<typeof myCart>>, TError = unknown>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof myCart>>, TError, TData>>;
    request?: SecondParameter<typeof httpRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useMyCart<TData = Awaited<ReturnType<typeof myCart>>, TError = unknown>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof myCart>>, TError, TData>>;
    request?: SecondParameter<typeof httpRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getMyCartQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getSetCartQuantityUrl = (productId: string) => {
  return `/api/v1/checkout/cart/items/${productId}`;
};

export const setCartQuantity = async (
  productId: string,
  setQuantityRequest: SetQuantityRequest,
  options?: Parameters<typeof httpRequest>[1],
): Promise<CartResponse> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(
          h as Iterable<Iterable<string>>,
          (entry) => Array.from(entry) as [string, string],
        ),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
  return httpRequest<CartResponse>(getSetCartQuantityUrl(productId), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...getHeaders(options?.headers) },
    body: JSON.stringify(setQuantityRequest),
  });
};

export const getSetCartQuantityMutationKey = () => ["setCartQuantity"] as const;

export const getSetCartQuantityMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setCartQuantity>>,
    TError,
    SetCartQuantityMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof httpRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof setCartQuantity>>,
  TError,
  SetCartQuantityMutationVariables,
  TContext
> => {
  const mutationKey = getSetCartQuantityMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof setCartQuantity>>,
    SetCartQuantityMutationVariables
  > = (props) => {
    const { productId, data } = props ?? {};

    return setCartQuantity(productId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SetCartQuantityMutationResult = NonNullable<
  Awaited<ReturnType<typeof setCartQuantity>>
>;
export type SetCartQuantityMutationBody = SetQuantityRequest;
export type SetCartQuantityMutationError = unknown;
export type SetCartQuantityMutationVariables = { productId: string; data: SetQuantityRequest };

export const useSetCartQuantity = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof setCartQuantity>>,
      TError,
      SetCartQuantityMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof httpRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof setCartQuantity>>,
  TError,
  SetCartQuantityMutationVariables,
  TContext
> => {
  return useMutation(getSetCartQuantityMutationOptions(options), queryClient);
};
export const getMergeCartUrl = () => {
  return `/api/v1/checkout/cart/merge`;
};

export const mergeCart = async (
  mergeCartRequest: MergeCartRequest,
  options?: Parameters<typeof httpRequest>[1],
): Promise<CartResponse> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(
          h as Iterable<Iterable<string>>,
          (entry) => Array.from(entry) as [string, string],
        ),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
  return httpRequest<CartResponse>(getMergeCartUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...getHeaders(options?.headers) },
    body: JSON.stringify(mergeCartRequest),
  });
};

export const getMergeCartMutationKey = () => ["mergeCart"] as const;

export const getMergeCartMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof mergeCart>>,
    TError,
    MergeCartMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof httpRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof mergeCart>>,
  TError,
  MergeCartMutationVariables,
  TContext
> => {
  const mutationKey = getMergeCartMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof mergeCart>>,
    MergeCartMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return mergeCart(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type MergeCartMutationResult = NonNullable<Awaited<ReturnType<typeof mergeCart>>>;
export type MergeCartMutationBody = MergeCartRequest;
export type MergeCartMutationError = unknown;
export type MergeCartMutationVariables = { data: MergeCartRequest };

export const useMergeCart = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof mergeCart>>,
      TError,
      MergeCartMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof httpRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof mergeCart>>,
  TError,
  MergeCartMutationVariables,
  TContext
> => {
  return useMutation(getMergeCartMutationOptions(options), queryClient);
};
export const getCheckoutQuoteUrl = () => {
  return `/api/v1/checkout/cart/quote`;
};

export const checkoutQuote = async (
  checkoutQuoteRequest: CheckoutQuoteRequest,
  options?: Parameters<typeof httpRequest>[1],
): Promise<CartResponse> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(
          h as Iterable<Iterable<string>>,
          (entry) => Array.from(entry) as [string, string],
        ),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
  return httpRequest<CartResponse>(getCheckoutQuoteUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...getHeaders(options?.headers) },
    body: JSON.stringify(checkoutQuoteRequest),
  });
};

export const getCheckoutQuoteMutationKey = () => ["checkoutQuote"] as const;

export const getCheckoutQuoteMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof checkoutQuote>>,
    TError,
    CheckoutQuoteMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof httpRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof checkoutQuote>>,
  TError,
  CheckoutQuoteMutationVariables,
  TContext
> => {
  const mutationKey = getCheckoutQuoteMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof checkoutQuote>>,
    CheckoutQuoteMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return checkoutQuote(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CheckoutQuoteMutationResult = NonNullable<Awaited<ReturnType<typeof checkoutQuote>>>;
export type CheckoutQuoteMutationBody = CheckoutQuoteRequest;
export type CheckoutQuoteMutationError = unknown;
export type CheckoutQuoteMutationVariables = { data: CheckoutQuoteRequest };

export const useCheckoutQuote = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof checkoutQuote>>,
      TError,
      CheckoutQuoteMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof httpRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof checkoutQuote>>,
  TError,
  CheckoutQuoteMutationVariables,
  TContext
> => {
  return useMutation(getCheckoutQuoteMutationOptions(options), queryClient);
};
export const getGuestQuoteUrl = () => {
  return `/api/v1/checkout/quote`;
};

export const guestQuote = async (
  guestQuoteRequest: GuestQuoteRequest,
  options?: Parameters<typeof httpRequest>[1],
): Promise<QuoteResponse> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(
          h as Iterable<Iterable<string>>,
          (entry) => Array.from(entry) as [string, string],
        ),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
  return httpRequest<QuoteResponse>(getGuestQuoteUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...getHeaders(options?.headers) },
    body: JSON.stringify(guestQuoteRequest),
  });
};

export const getGuestQuoteMutationKey = () => ["guestQuote"] as const;

export const getGuestQuoteMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof guestQuote>>,
    TError,
    GuestQuoteMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof httpRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof guestQuote>>,
  TError,
  GuestQuoteMutationVariables,
  TContext
> => {
  const mutationKey = getGuestQuoteMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof guestQuote>>,
    GuestQuoteMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return guestQuote(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GuestQuoteMutationResult = NonNullable<Awaited<ReturnType<typeof guestQuote>>>;
export type GuestQuoteMutationBody = GuestQuoteRequest;
export type GuestQuoteMutationError = unknown;
export type GuestQuoteMutationVariables = { data: GuestQuoteRequest };

export const useGuestQuote = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof guestQuote>>,
      TError,
      GuestQuoteMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof httpRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof guestQuote>>,
  TError,
  GuestQuoteMutationVariables,
  TContext
> => {
  return useMutation(getGuestQuoteMutationOptions(options), queryClient);
};
